"use strict";

var _ = require("underscore");
var moment = require("moment");
var Reflux = require("reflux");

var MultiActionStore = require("app/util/flux/multi-action-store");
var ActivityDraft = require("app/util/browser/activity-draft");
var URLUtil = require("app/util/browser/url");

function createStore(instanceKey) {
  var activityInputActions = ActivityInputActions(instanceKey);
  var scheduleActions = ScheduleActions(instanceKey);
  var entitySuggestionsActions = EntitySuggestionsActions(instanceKey);

  var store = Reflux.createStore({
    state: {},
    setState: function(state){
      this.state = _.defaults(state, this.state);
      this.trigger(this.state);
      return this.state;
    },
    getInitialState: function() {
      var env = URLUtil.getPageEnv(window.location);
      var entityId = URLUtil.getEntityId(window.location.search);
      var storagedActivity = ActivityDraft.getActivity();
      var dueDate = null;

      if (storagedActivity.date && storagedActivity.time) {
        dueDate = storagedActivity.date + " " + storagedActivity.time;
      }

      var data = {
        activityId: null,
        instanceKey: null,
        entity: storagedActivity.entity,
        dueDate: dueDate,
        finishedDate: null,
        createdBy: null,
        dropbox: null,
        expandedActions: false,
        expandedText: false,
        discardedText: "",
        text: storagedActivity.text,
        editing: false,
        isTask: false,
        saveButtonPressed: false,
        isReadyToSave: false,
        selectedTypeId: storagedActivity.type,
        errorMsg: null,
        owners: storagedActivity.selectedUsers,
        files: [],
        metrics: storagedActivity.metrics,
        types: [],
        env: env,
        entityId: entityId
      };
      return data;
    },
    init: function(){
      this.listenTo(activityInputActions.toggle, this.onToggle);
      this.listenTo(activityInputActions.addFile.starting, this.onAddFileStarting);
      this.listenTo(activityInputActions.addFile.progress, this.onAddFileProgress);
      this.listenTo(activityInputActions.addFile.completed, this.onAddFileCompleted);
      this.listenTo(activityInputActions.setDueDateAndOwners, this.onSetDueDateAndOwners);
      this.listenTo(activityInputActions.removeFile, this.onRemoveFile);
      this.listenTo(activityInputActions.selectType, this.onSelectType);
      this.listenTo(activityInputActions.setMetric, this.onSetMetric);
      this.listenTo(activityInputActions.removeMetric, this.onRemoveMetric);
      this.listenTo(activityInputActions.setText, this.onSetText);
      this.listenTo(activityInputActions.refresh, this.onRefresh);
      this.listenTo(activityInputActions.save.completed, this.onSaveCompleted);
      this.listenTo(activityInputActions.save.failed, this.onSaveFailed);
      this.listenTo(activityInputActions.update.completed, this.onUpdateCompleted);
      this.listenTo(activityInputActions.update.failed, this.onSaveFailed);
      this.listenTo(activityInputActions.saveButtonPressed, this.onSaveButtonPressed);
      this.listenTo(activityInputActions.useDiscardedText, this.onUseDiscardedText);
      this.listenTo(activityInputActions.cancelEdition, this.onCancelEdition);
      this.listenTo(activityInputActions.setupEdit, this.onSetupEdit);
      this.listenTo(scheduleActions.define, this.onScheduleDefine);
      this.listenTo(activityInputActions.getActivityTypes.completed, this.onGetActivityTypesCompleted);
      this.listenTo(activityInputActions.populate, this.onPopulate);

      this.listenTo(entitySuggestionsActions.selectSuggestion, this.onSelectEntity);

      ActivitiesListingStore.listenTo(activityInputActions.save.completed, ActivitiesListingStore.onPush);
      ActivitiesListingStore.listenTo(activityInputActions.update.completed, ActivitiesListingStore.onUpdate);

      this.state = this.getInitialState();
    },
    onSetupEdit: function(activityInput){
      activityInput = keepInitialState(activityInput);
      this.setState(activityInput);
    },
    onPopulate: function(activityInput){
      this.setState(activityInput);
    },
    onToggle: function(expandedActions, expandedText){
      this.state.expandedActions = expandedActions;
      this.state.expandedText = expandedText;
      this.trigger(this.state);
    },
    onSetDueDateAndOwners: function(newDueDate, owners){
      var activityFromStorage = ActivityDraft.getActivity();

      activityFromStorage.date = null;
      activityFromStorage.time = null;
      this.state.dueDate = newDueDate;
      this.state.owners = owners;

      ActivityDraft.saveActivity(activityFromStorage);
      this.trigger(this.state);
    },
    onAddFileStarting: function(file){
      this.state.files.push(file);
      this.trigger(this.state);
    },
    onAddFileProgress: function(file, progress){
      var files = _.map(this.state.files, function(fileMap){
        if (fileMap.id == file.id) {
          fileMap.uploadState = "started";
          fileMap.progress = progress;
        }
        return fileMap;
      });
      this.state.files = files;
      this.trigger(this.state);
    },
    onAddFileCompleted: function(file){
      var allFilesUploaded = true;
      var files = _.map(this.state.files, function(fileMap){
        if (fileMap.id == file.id) {
          fileMap.uploadState = "completed";
        }
        if(allFilesUploaded && fileMap.uploadState != "completed") {
          allFilesUploaded = false;
        }
        return fileMap;
      });

      this.state.isReadyToSave = this.state.saveButtonPressed && allFilesUploaded;
      this.state.files = files;
      this.trigger(this.state);
    },
    onRemoveFile: function(id){
      var files = _.filter(this.state.files, function(f){
        if(f.id == id) { f.uploadState = "aborted"; }
        return f.id!=id;
      });
      this.state.saveButtonPressed = false;
      this.state.files = files;
      this.trigger(this.state);
    },
    onSetMetric: function(metric){
      var metricSelected = _.find(this.state.metrics, function(m){ return m.id == metric.id; });
      var activityFromStorage = ActivityDraft.getActivity();

      if(!metricSelected) {
        var newMetric = {
          id: metric.id,
          name: metric.nome,
          value: metric.valor
        };

        this.state.metrics.push(newMetric);
        activityFromStorage.metrics.push(newMetric);
        ActivityDraft.saveActivity(activityFromStorage);
        this.trigger(this.state);
      }
    },
    onRemoveMetric: function(metric){
      var activityFromStorage = ActivityDraft.getActivity();
      var newMetricArray = this.removeMetric(metric);

      activityFromStorage.metrics = newMetricArray;
      this.state.metrics = newMetricArray;

      ActivityDraft.saveActivity(activityFromStorage);
      this.trigger(this.state);
    },
    removeMetric: function (metric) {
      return _.filter(this.state.metrics, function(m){ return m.id!=metric.id; });
    },
    onSelectType: function(id, selected){
      var activityFromStorage = ActivityDraft.getActivity();
      activityFromStorage.type = selected ? id : "" || "";
      ActivityDraft.saveActivity(activityFromStorage);

      _.each(this.state.types, function(type, i){
        if(type.id==id) {
          type.selected = selected;
        } else {
          type.selected = false;
        }
      });
      this.trigger(this.state);
    },
    onSetText: function(text, isTypeChange, isTypeSelected){
      if(isTypeChange && !this.state.text && isTypeSelected){
        this.state.text = text;
      } else if(!isTypeChange) {
        this.state.text = text;
      } else if(isTypeChange && isTypeSelected) {
        var typeNames = _.pluck(this.state.types, "name");
        if(_.contains(typeNames, this.state.text)) {
          this.state.text = text;
        }
      }

      var activityFromStorage = ActivityDraft.getActivity();
      activityFromStorage.text = this.state.text || "";
      ActivityDraft.saveActivity(activityFromStorage);

      this.trigger(this.state);
    },
    onRefresh: function(){
      ActivityDraft.removeActivity();

      var isTask = this.state.isTask;
      var discardedText = this.state.text;
      var instanceKey = this.state.instanceKey;
      var entity = this.state.entity;
      var owners = this.state.owners;
      var dueDate = this.state.dueDate;
      var env = this.state.env;
      var entityId = this.state.entityId;

      var types = this.state.types;
      _.each(types, function(type){
        type.selected = false;
      });

      this.state = this.getInitialState();

      this.state.discardedText = discardedText;
      this.state.types = types;
      this.state.instanceKey = instanceKey;
      this.state.entity = entity;
      this.state.env = env;
      this.state.entityId = entityId;

      if (instanceKey === "activityInputNew" && isTask) {
        this.state.entity = null;
        this.state.isTask = isTask;
      } else if (isTask) {
        this.state.entity = null;
        this.state.isTask = isTask;
        this.state.owners = owners;
        this.state.dueDate = dueDate;
      }

      this.trigger(this.state);
    },
    onSelectEntity: function (entity) {
      var activityFromStorage = ActivityDraft.getActivity();

      activityFromStorage.entity = entity || {};
      this.state.entity = entity;

      ActivityDraft.saveActivity(activityFromStorage);
      this.trigger(this.state);
    },
    onSaveCompleted: function (savedActivity, response) {
      this.state.text = null;
      this.onRefresh();
    },
    onSaveFailed: function(errorMsg){

      this.state.saveButtonPressed = false;
      this.state.isReadyToSave = false;
      _.each(this.state.metrics, function(metric, i){
        if(metric.isActivityType) {
          this.state.metrics.splice(i, 1);
        }
      }.bind(this));

      this.state.errorMsg = errorMsg;
      this.trigger(this.state);
      this.state.errorMsg = null;
    },
    onUpdateCompleted: function (updatedActivity, response) {
      this.onRefresh();
    },
    onSaveButtonPressed: function () {
      this.state.saveButtonPressed = true;

      // It is only ready to save when all files are in the completed state
      // or when there are no files
      this.state.isReadyToSave = !_.find(this.state.files, function(fileMap) {
        return fileMap.uploadState != "completed";
      });
      this.trigger(this.state);
    },
    onUseDiscardedText: function (triggerStateChange) {
      if(this.state.discardedText) {
        this.state.text = this.state.discardedText;
      }
      this.state.discardedText = null;
      // Prevents listener components from rendering twice if not needed
      if(triggerStateChange) {
        this.trigger(this.state);
      }
    },
    onScheduleDefine: function(date, time, selectedUsers){
      if(date&&selectedUsers.length>0){
        this.state.dueDate = date + " " + time;
        this.state.owners = selectedUsers;
        this.trigger(this.state);
      }
    },
    onCancelEdition: function(){
      this.state.editing = false;
      this.trigger(this.state);
    },
    onGetActivityTypesCompleted: function(activityTypes){
      var type = _.find(activityTypes, function(t){ return t.id==this.state.selectedTypeId; }.bind(this));
      if(type) {
        type.selected = true;
      }
      this.state.types = activityTypes;
      this.trigger(this.state);
    }
  });

  return store;
};

function keepInitialState(activityInput) {
  activityInput.initialDueDate = activityInput.dueDate;
  return activityInput;
}

module.exports = MultiActionStore.factory(createStore);

var ActivityInputActions = require("app/screens/Activity/actions/activity-input-actions");
var ScheduleActions = require("app/screens/Activity/actions/schedule-actions");
var EntitySuggestionsActions = require("app/shared/actions/entity-suggestions-actions");
var ActivitiesListingStore = require("app/screens/Activity/stores/activities-listing-store");



// WEBPACK FOOTER //
// ./app/screens/Activity/stores/activity-input-store.js